/** Enlace del botón "¿Conocías nuestro stock de usados?". Reemplazalo por el link definitivo. */
export const usedStockUrl = 'https://catalogo.automotoresvcars.com/';

/** Aplicación web de Apps Script de la planilla VCARS 0 KM (independiente de usados). */
export const sheetsEndpoint =
  'https://script.google.com/macros/s/AKfycbwGKrBpW9cgGAVv-f21TzDsQGiWdiXPl7k5oHXwybOxrA34yl4vUzgZfSlWgFGOOepN/exec';
